import 'whatwg-fetch';
import 'core-js'; // not really ideal to load every polyfill :/ but I could'nt figure out what IE is complaining about

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {StoreContext} from './helpers/StoreContext';
import RootStore from './stores/RootStore';

ReactDOM.render(
  <StoreContext.Provider value={new RootStore()}>
    <App/>
  </StoreContext.Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
